<template>
  <section>
    <div>
      <h2>Report Status Overview</h2>
    </div>
    <div class="columns is-multiline">
      <div class="column is-half-tablet is-one-quarter-desktop">
        <div class="card is-card-widget tile is-child">
          <div class="card-content gauge">
            <div class="level is-mobile">
              <div class="level-left">
                <div class="is-widget-label">
                  <h3 class="danger">Overdue</h3>
                  <div class="overdue-past-period-status-sm-txt danger">
                    Past Periods
                  </div>
                  <h4 class="danger three-lines">
                    {{ statusData.overdue_past_periods_reports }}
                  </h4>
                </div>
              </div>
              <div class="level-right has-widget-icon">
                <div class="is-widget-icon">
                  <b-icon
                    icon="calendar-clock-outline"
                    type="is-danger"
                    size="is-large"
                  ></b-icon>
                </div>
              </div>
            </div>
          </div>
          <!---->
        </div>
      </div>

      <div class="column is-half-tablet is-one-quarter-desktop">
        <div class="card is-card-widget tile is-child">
          <div class="card-content gauge">
            <div class="level is-mobile">
              <div class="level-left">
                <div class="is-widget-label">
                  <h3 class="danger">Overdue</h3>
                  <h4 class="danger">
                    {{ statusData.overdue_reports }}
                  </h4>
                </div>
              </div>
              <div class="level-right has-widget-icon">
                <div class="is-widget-icon">
                  <b-icon
                    icon="clock-alert-outline"
                    type="is-danger"
                    size="is-large"
                  ></b-icon>
                </div>
              </div>
            </div>
          </div>
          <!---->
        </div>
      </div>
      <div class="column is-half-tablet is-one-quarter-desktop">
        <div class="card is-card-widget tile is-child">
          <div class="card-content gauge">
            <div class="level is-mobile">
              <div class="level-left">
                <div class="is-widget-label">
                  <h3 class="warning">Due</h3>
                  <h4 class="warning">
                    {{ statusData.due_reports }}
                  </h4>
                </div>
              </div>
              <div class="level-right has-widget-icon">
                <div class="is-widget-icon">
                  <b-icon
                    icon="alert-circle-outline"
                    type="is-warning"
                    size="is-large"
                    class="warning"
                  ></b-icon>
                </div>
              </div>
            </div>
          </div>
          <!---->
        </div>
      </div>
      <div class="column is-half-tablet is-one-quarter-desktop">
        <div class="card is-card-widget tile is-child">
          <div class="card-content gauge">
            <div class="level is-mobile">
              <div class="level-left">
                <div class="is-widget-label">
                  <h3>Completed</h3>
                  <h4>
                    {{ statusData.completed_reports }}/{{
                      statusData.total_reports
                    }}
                  </h4>
                </div>
              </div>
              <div class="level-right has-widget-icon">
                <div class="is-widget-icon">
                  <b-icon
                    icon="flag-checkered"
                    type="is-grey"
                    size="is-large"
                  ></b-icon>
                </div>
              </div>
            </div>
          </div>
          <!---->
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// @group Dashboard
export default {
  name: "ReportStatusOverview",
  props: {
    statusData: {
      type: Object
    }
  },
  data() {
    return {};
  }
};
</script>
